// Lib
import React from 'react';
import { connect } from 'react-redux';

// Utils
import { getElementId, getTextContent } from '../../../../common/elements/utils/elementPropertyUtils';

// Actions
import { openDefaultAssignmentPopup } from '../pills/assignment/taskAssignmentActions';
import { openCurrentlyEditingDueDatePopup } from '../pills/assignment/dueDate/taskDueDateActions';

// Hooks
import { useElementTiptapContent } from '../../../../common/tiptap/conversion/elementConversion/useElementTiptapContent';

// Components
import TaskTiptapEditor, { TaskTiptapEditorProps } from './TaskTiptapEditor';

// Types
import { DocumentType } from '../../../../common/tiptap/conversion/elementConversion/elementConversion';
import { useTranslator } from "../../../components/i18n/useTranslator";

type TaskEditorProps = Omit<TaskTiptapEditorProps, 'textContent'>;

const mapDispatchToProps = (dispatch: Function) => ({
    dispatchOpenAssignmentPopup: () => dispatch(openDefaultAssignmentPopup()),
    dispatchOpenDueDatePopup: () => dispatch(openCurrentlyEditingDueDatePopup()),
});

const TaskEditor = (props: TaskEditorProps) => {
    const translate = useTranslator('elements', 'elementTypes.task');
    const {
        element,
        isEditable,
        isEditing,
        isParentTaskListSingleSelected,
        spellCheck,
        currentEditorKey,
        currentEditorId,
        saveContent,
        startEditing,
        onKeyboardDelete,
        changeIndentation,
        goToPreviousTask,
        goToNextTask,
        placeholder,
        onEnter,
        createMultipleNewTasksWithContent,
        toggleComplete,
        dispatchOpenAssignmentPopup,
        dispatchOpenDueDatePopup,
        onStartBackspace,
        onEndDelete,
        isFocusedForegroundElement,
    } = props;

    const elementId = getElementId(element);
    const textContent = getTextContent(element);
    const tiptapContent = useElementTiptapContent(textContent, elementId, DocumentType.textContent);

    return (
        <TaskTiptapEditor
            element={element}
            textContent={tiptapContent}
            currentEditorKey={currentEditorKey}
            currentEditorId={currentEditorId}
            isEditable={isEditable}
            isEditing={isEditing}
            isParentTaskListSingleSelected={isParentTaskListSingleSelected}
            spellCheck={spellCheck}
            placeholder={placeholder || translate('editor.placeholder')}
            saveContent={saveContent}
            startEditing={startEditing}
            onEnter={onEnter}
            onKeyboardDelete={onKeyboardDelete}
            changeIndentation={changeIndentation}
            toggleComplete={toggleComplete}
            dispatchOpenDueDatePopup={dispatchOpenDueDatePopup}
            dispatchOpenAssignmentPopup={dispatchOpenAssignmentPopup}
            goToPreviousTask={goToPreviousTask}
            goToNextTask={goToNextTask}
            onStartBackspace={onStartBackspace}
            onEndDelete={onEndDelete}
            isFocusedForegroundElement={isFocusedForegroundElement}
            createMultipleNewTasksWithContent={createMultipleNewTasksWithContent}
        />
    );
};

export default connect(null, mapDispatchToProps)(TaskEditor);
